import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Page from 'flow/components/Setting/Page';
import SettingHeader from 'flow/components/Setting/SettingHeader';
import Loading from 'flow/components/ui-components/Loading';
import Tabs, { TabProps } from 'flow/components/ui-components/Tabs';
import { TranscriptionDestinationType } from 'flow/hooks/api/useTranscriptionBilling';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectHasCapabilityBusinessTranscription,
    selectHasCapabilityPersonalTranscription,
} from 'flow/selectors/own-extension-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';
import useTranscriptionSettingsReady from '../useTranscriptionSettingsReady';
import QuotaSection from './QuotaSection';

const getQuotaTabs = (i18next: { t: (key: string) => string }): TabProps[] => [
    {
        key: 'personal',
        label: i18next.t('settings.transcriptions.quota.personal'),
    },
    {
        key: 'business',
        label: i18next.t('settings.transcriptions.quota.business'),
    },
];

const QuotaContent = () => {
    const { i18next } = useAppContext();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const history = useHistory();
    const hasPersonal = useAppSelector(
        selectHasCapabilityPersonalTranscription,
    );
    const hasBusiness = useAppSelector(
        selectHasCapabilityBusinessTranscription,
    );

    const [selected, setSelected] = useState<TranscriptionDestinationType>(
        hasPersonal ? 'personal' : 'business',
    );

    const hasBothPersonalAndBusiness = hasPersonal && hasBusiness;

    return (
        <Page
            childrenClassName="mx-auto w-full max-w-screen-sm p-3"
            header="settings.transcriptions.quota"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.transcriptions'], {
                        extensionKey,
                    }),
                )
            }
        >
            {hasBothPersonalAndBusiness ? (
                <Tabs
                    className="mb-4"
                    selectedKey={selected}
                    tabs={getQuotaTabs(i18next)}
                    onClick={(tab) =>
                        setSelected(tab.key as TranscriptionDestinationType)
                    }
                />
            ) : null}
            <SettingHeader>{i18next.t('settings.usage.usage')}</SettingHeader>
            <QuotaSection extensionKey={extensionKey} destination={selected} />
        </Page>
    );
};

const SettingsTranscriptionsQuota = () => {
    const ready = useTranscriptionSettingsReady();

    if (!ready) {
        return <Loading />;
    }

    return <QuotaContent />;
};

export default SettingsTranscriptionsQuota;
